export function normalizeNcOrigin(detail = {}) {
    // Le API vecie no mandava gnente: qua tenemo la riapertura retrocompatibile.
    const odp = detail.odp || null;
    if (detail.numero_fase === null || detail.numero_fase === undefined || detail.numero_fase === "") {
        return { odp, phase: null };
    }
    const parsedPhase = Number(detail.numero_fase);
    const phase = Number.isInteger(parsedPhase) ? parsedPhase : null;
    return { odp, phase };
}

export function findNcPhase(phases = [], selectedPhase = null) {
    const parsedPhase = Number(selectedPhase);
    if (!Number.isInteger(parsedPhase)) return null;
    return phases.find((phase) => Number(phase.numero) === parsedPhase) || null;
}

export function ncOriginSelection(detail = {}) {
    const phase = Number(detail.numero_fase);
    if (!Number.isInteger(phase)) return null;
    if (phase === 999) {
        return detail.nc_origine_id ? `origin:${detail.nc_origine_id}` : null;
    }
    return `phase:${phase}`;
}

export function groupedNcOriginChoices(phases = [], origins = []) {
    const realPhases = phases
        .filter((phase) => Number(phase.numero) !== 999)
        .map((phase) => ({
            ...phase,
            value: `phase:${Number(phase.numero)}`,
            type: "phase",
        }));
    const nonProductive = origins
        .filter((origin) => origin.id && origin.id !== "O0")
        .map((origin) => ({
            ...origin,
            value: `origin:${origin.id}`,
            type: "origin",
        }));
    return [
        { header: "Fasi reali dell’ODP" },
        ...realPhases,
        { divider: true },
        { header: "Origini non produttive" },
        ...nonProductive,
    ];
}

export function resolveNcOriginChoice(choice, choices = []) {
    const selected = choices.find((item) => item.value === choice);
    if (!selected) return { phase: null, originId: null, originLabel: "" };
    if (selected.type === "origin") {
        return { phase: 999, originId: selected.id, originLabel: selected.label };
    }
    return {
        phase: Number(selected.numero),
        originId: selected.origine_id,
        originLabel: selected.origine || "",
    };
}

export function ncOperatorsForPhase(phases = [], selectedPhase = null, fallback = []) {
    const phase = findNcPhase(phases, selectedPhase);
    const operators = phase && Array.isArray(phase.operatori) ? phase.operatori : fallback;
    const seen = new Set();
    return (Array.isArray(operators) ? operators : []).filter((operator) => {
        const number = String(operator && operator.matricola || "").trim();
        if (!number || seen.has(number)) return false;
        seen.add(number);
        return true;
    });
}

export const EXTERNAL_ORIGIN_IDS = new Set(["O1", "O17"]);

export function ncRequiresInternalResponsible(originId, selectedPhase = null) {
    const phase = Number(selectedPhase);
    return Number.isInteger(phase) && !EXTERNAL_ORIGIN_IDS.has(originId);
}

export function ncResponsibleOptions(
    phases = [],
    selectedPhase = null,
    fallback = [],
    internalOperators = []
) {
    if (Number(selectedPhase) === 999) {
        return ncOperatorsForPhase([], null, internalOperators);
    }
    return ncOperatorsForPhase(phases, selectedPhase, fallback);
}

export const PRODUCTIVE_ORIGIN_IDS = new Set([
    "O2", "O3", "O4", "O5", "O6", "O7", "O8", "O13", "O14", "O15", "O17",
]);

export const PROBLEM_SUGGESTIONS = [
    "Dimensione fuori tolleranza.",
    "Foro mancante o in posizione errata.",
    "Piegatura non conforme.",
    "Saldatura non conforme.",
    "Verniciatura non conforme.",
    "Trattamento superficiale non conforme.",
    "Presenza di bave.",
    "Presenza di graffi o ammaccature.",
    "Materiale o spessore errato.",
    "Disegno o revisione errata.",
    "Quantità consegnata errata.",
    "Imballaggio non adeguato.",
    "Componente mancante.",
    "Montaggio non conforme.",
];

export const CORRECTION_SUGGESTIONS = [
    "Materiale segregato.",
    "Controllo al 100% del lotto.",
    "Particolari rilavorati.",
    "Particolari rifatti.",
    "Materiale sostituito.",
    "Materiale scartato.",
    "Materiale accettato in deroga.",
    "Materiale reso al fornitore.",
    "Cliente informato.",
    "Bloccate le spedizioni dello stesso articolo.",
];

const PERMANENT_SUGGESTIONS = {
    production: [
        "Aggiunto controllo alla fase.",
        "Introdotto controllo del primo pezzo.",
        "Introdotto controllo del materiale prima della lavorazione.",
        "Aggiornata specifica del materiale.",
        "Aggiornata istruzione operativa.",
        "Modificati i parametri di lavorazione.",
        "Modificato il programma macchina.",
        "Modificata o sostituita l’attrezzatura.",
        "Aggiunta maschera di controllo.",
        "Formato il personale sul nuovo metodo.",
        "Definite e registrate le condizioni ambientali richieste.",
        "Aggiunto controllo delle condizioni ambientali prima della lavorazione.",
    ],
    technical: [
        "Aggiornato il disegno.",
        "Aggiornata la revisione.",
        "Corretta la distinta base.",
        "Corretta l’istruzione tecnica.",
        "Aggiunta verifica documentale prima del rilascio.",
        "Aggiunto controllo della revisione prima della produzione.",
    ],
    quality: [
        "Aggiornato il piano di controllo.",
        "Aumentata la frequenza del controllo.",
        "Aggiunta registrazione obbligatoria dell’esito.",
        "Aggiunto controllo finale.",
        "Aggiunto controllo prima dell’imballaggio.",
    ],
    logistics: [
        "Aggiornata istruzione di imballaggio.",
        "Aggiunte protezioni al materiale.",
        "Modificata modalità di movimentazione.",
        "Aggiunto controllo prima della spedizione.",
        "Separata l’ubicazione del materiale conforme.",
    ],
    supplier: [
        "Inviata richiesta formale di azione correttiva.",
        "Aggiornata specifica di fornitura.",
        "Introdotto controllo in accettazione.",
        "Richiesto rapporto di controllo.",
        "Prevista verifica sulla fornitura successiva.",
    ],
};

const PERMANENT_SUGGESTION_TERMS_BY_CAUSE = {
    C1: ["istruzione", "metodo", "controllo", "verifica"],
    C2: ["materiale"],
    C3: ["parametri", "programma macchina", "attrezzatura", "maschera"],
    C4: ["istruzione", "metodo", "personale", "controllo"],
    C5: ["ambientali"],
    C6: ["fornitura", "fornitore", "rapporto"],
    C7: ["fornitura", "accettazione", "specifica", "rapporto"],
    C8: ["disegno", "revisione", "distinta", "istruzione tecnica", "documentale"],
    C9: ["imballaggio", "protezioni", "movimentazione", "spedizione", "ubicazione"],
    C10: ["controllo", "frequenza", "registrazione", "verifica"],
};

const GENERIC_TEXTS = new Set([
    "nessuna", "nessuno", "na", "n/a", "avvisato operatore", "avvisato fornitore",
    "fare attenzione", "controllare meglio", "problema risolto", "aggiunto nota",
    "aggiunta nota", "aggiunto foto", "nota",
]);
const MIN_DEFINITIVE_TEXT_LENGTH = 30;
const MIN_MOTIVATION_TEXT_LENGTH = 10;
const GENERIC_MOTIVATIONS = new Set([
    "nessuna", "na", "n-a", "n/a", "non serve", "ok", "fatto",
]);

function normalizedText(value) {
    return String(value || "").trim().toLocaleLowerCase("it").replace(/\s+/g, " ");
}

function isConcreteText(value) {
    const normalized = normalizedText(value).replace(/[ .;,:!?]+$/g, "");
    return normalized.length >= MIN_DEFINITIVE_TEXT_LENGTH && !GENERIC_TEXTS.has(normalized);
}

let authoritativeSuggestions = {
    problems: PROBLEM_SUGGESTIONS,
    corrections: CORRECTION_SUGGESTIONS,
    actions: Object.values(PERMANENT_SUGGESTIONS).flat(),
};

export function configureNcSuggestions(suggestions = {}) {
    authoritativeSuggestions = {
        problems: Array.isArray(suggestions.problemi) ? suggestions.problemi : PROBLEM_SUGGESTIONS,
        corrections: Array.isArray(suggestions.correzioni) ? suggestions.correzioni : CORRECTION_SUGGESTIONS,
        actions: Array.isArray(suggestions.azioni)
            ? suggestions.azioni
            : Object.values(PERMANENT_SUGGESTIONS).flat(),
    };
}

function isOfficialText(value, suggestions = []) {
    let remaining = normalizedText(value);
    [...suggestions]
        .sort((left, right) => right.length - left.length)
        .forEach((suggestion) => {
            remaining = remaining.replace(normalizedText(suggestion), " ");
        });
    return Boolean(normalizedText(value)) && !remaining.replace(/[ .;,:!?]+/g, "");
}

function isValidGuidedText(value, suggestions) {
    return isOfficialText(value, suggestions) || isConcreteText(value);
}

export function isProductiveNcOrigin(originId) {
    return PRODUCTIVE_ORIGIN_IDS.has(originId);
}

export function appendNcSuggestion(current, suggestion) {
    const text = String(current || "").trim();
    const next = String(suggestion || "").trim();
    if (!next || text.toLocaleLowerCase("it").includes(next.toLocaleLowerCase("it"))) {
        return text;
    }
    return text ? `${text} ${next}` : next;
}

const CAUSE_IDS_BY_ORIGIN = {
    O1: ["C1", "C7", "C8"],
    O9: ["C10"],
    O10: ["C9", "C10"],
    O11: ["C1", "C8", "C10"],
    O12: ["C1", "C8", "C10"],
    O16: ["C9", "C10"],
    O17: ["C6", "C7", "C10"],
};

export function causeOptionsForOrigin(causes = [], originId = null) {
    const allowed = CAUSE_IDS_BY_ORIGIN[originId]
        || (isProductiveNcOrigin(originId) ? ["C1", "C2", "C3", "C4", "C5", "C10"] : []);
    return causes.filter((cause) => allowed.includes(cause.id));
}

export function ncDecisionChecklist(detail = {}, checklist = []) {
    const byKey = Object.fromEntries(checklist.map((item) => [item.key, item.complete]));
    return [
        { key: "origin", label: "Origine", complete: Boolean(byKey.origin && byKey.phase) },
        { key: "problem", label: "Problema", complete: Boolean(byKey.problem) },
        { key: "cause", label: "Causa", complete: Boolean(detail.nc_causa_id) },
        { key: "action", label: "Azione", complete: Boolean(byKey.permanent_action) },
    ];
}

export function ncNonDetectionCause(selectedPhase = null, phases = []) {
    if (Number(selectedPhase) === 999) {
        return "Il flusso di verifica delle informazioni o del materiale non prevedeva un controllo sufficientemente efficace prima della consegna.";
    }
    const current = Number(selectedPhase);
    if (!Number.isInteger(current)) return "";
    const controlTerms = ["controll", "qualità", "qualita", "collaud", "verifica", "ispezion"];
    const hasFollowingControl = phases.some((phase) => (
        Number(phase.numero) > current
        && controlTerms.some((term) => `${phase.codice || ""} ${phase.descrizione || ""}`.toLocaleLowerCase("it").includes(term))
    ));
    return hasFollowingControl
        ? "Il ciclo prevedeva un controllo successivo, ma il metodo o il criterio applicato non ha consentito di intercettare la non conformità."
        : "Il ciclo non prevedeva, dopo la fase di origine, un controllo specifico in grado di intercettare la non conformità.";
}

export function permanentSuggestionsForOrigin(originId, causeId = null) {
    let suggestions = [];
    if (originId === "O1") {
        suggestions = [...PERMANENT_SUGGESTIONS.technical, ...PERMANENT_SUGGESTIONS.supplier];
    } else if (originId === "O17") {
        suggestions = PERMANENT_SUGGESTIONS.supplier;
    } else if (isProductiveNcOrigin(originId)) {
        suggestions = PERMANENT_SUGGESTIONS.production;
    } else if (["O11", "O12"].includes(originId)) {
        suggestions = PERMANENT_SUGGESTIONS.technical;
    } else if (originId === "O9") {
        suggestions = PERMANENT_SUGGESTIONS.quality;
    } else if (["O10", "O16"].includes(originId)) {
        suggestions = PERMANENT_SUGGESTIONS.logistics;
    }

    const authoritative = new Set(
        authoritativeSuggestions.actions.map((suggestion) => normalizedText(suggestion))
    );
    suggestions = suggestions.filter((suggestion) => authoritative.has(normalizedText(suggestion)));
    const terms = PERMANENT_SUGGESTION_TERMS_BY_CAUSE[causeId];
    if (!terms) return suggestions;
    return suggestions.filter((suggestion) => {
        const normalized = suggestion.toLocaleLowerCase("it");
        return terms.some((term) => normalized.includes(term));
    });
}

export function ncCustomerLabel(detail = {}) {
    const code = String(detail.cliente_codice || "").trim();
    const name = String(detail.cliente || "").trim();
    if (code && name.toLocaleLowerCase("it").startsWith(code.toLocaleLowerCase("it"))) {
        return name;
    }
    return [code, name].filter(Boolean).join(" – ");
}

export function ncLiveChecklist(
    detail = {},
    selectedOdp = null,
    selectedPhase = null,
    validOdp = Boolean(selectedOdp)
) {
    const noAction = Boolean(detail.azione_non_necessaria);
    const motivation = normalizedText(detail.motivazione_azione_non_necessaria);
    const permanentValid = noAction
        ? motivation.replace(/[ .;,:!?]+$/g, "").length >= MIN_MOTIVATION_TEXT_LENGTH
            && !GENERIC_MOTIVATIONS.has(normalizedText(motivation).replace(/[ .;,:!?]+$/g, ""))
        : isValidGuidedText(
            detail.azione_correttiva_permanente,
            authoritativeSuggestions.actions
        );
    return [
        { key: "return_data", label: detail.scope === "internal" ? "Dati della NC interna recuperati" : "Dati del reso recuperati", complete: Boolean(detail.numero && detail.riga && detail.articolo && detail.data_nc && detail.descrizione_articolo && (detail.scope === "internal" ? detail.sede_interna : detail.cliente_codice && detail.cliente && detail.sede_cliente)) },
        { key: "quantity", label: "Quantità e unità di misura disponibili", complete: Number(detail.quantita_non_conforme) > 0 && Boolean(String(detail.unita_misura || "").trim()) },
        { key: "origin", label: "Origine selezionata", complete: Boolean(detail.nc_origine_id && detail.nc_origine_id !== "O0") },
        { key: "cause", label: "Categoria causa selezionata", complete: Boolean(detail.nc_causa_id) },
        { key: "odp", label: "ODP individuato", complete: Boolean(selectedOdp && validOdp) },
        { key: "phase", label: "Fase o origine non produttiva individuata", complete: selectedPhase !== null && selectedPhase !== undefined && selectedPhase !== "" },
        { key: "supplier", label: "Fornitore / terzista origine NC", complete: detail.nc_origine_id !== "O17" || Boolean(detail.fornitore_origine && detail.fornitore_origine.codice) },
        { key: "problem", label: "Problema descritto", complete: Boolean(normalizedText(detail.problema)) },
        { key: "correction", label: "Trattamento della non conformità", complete: isValidGuidedText(detail.correzione_immediata, authoritativeSuggestions.corrections) },
        { key: "permanent_action", label: "Azione permanente o motivazione", complete: permanentValid },
    ];
}

export function ncGenerationErrors(
    detail = {},
    selectedOdp = null,
    selectedPhase = null,
    validOdp = Boolean(selectedOdp)
) {
    const checklist = ncLiveChecklist(detail, selectedOdp, selectedPhase, validOdp);
    const missing = new Set(
        checklist.filter((item) => !item.complete).map((item) => item.key)
    );
    const errors = [];
    if (missing.has("return_data")) errors.push(detail.scope === "internal" ? "dati della NC interna, sede o articolo incompleti" : "dati cliente, sede o articolo incompleti");
    if (missing.has("quantity")) errors.push("quantità o unità di misura mancanti");
    if (missing.has("origin") || missing.has("phase")) {
        errors.push("Selezionare la fase o l’origine non produttiva del difetto.");
    }
    if (missing.has("cause")) errors.push("categoria causa mancante");
    if (missing.has("odp")) errors.push(detail.scope === "internal" ? "ODP o data di riferimento non validi" : "ODP o data di versamento non validi");
    if (missing.has("supplier")) errors.push("Selezionare il fornitore o terzista collegato all’ODP e alla fase.");
    if (missing.has("problem")) errors.push("Selezionare un problema preimpostato oppure descrivere il problema.");
    if (missing.has("correction")) errors.push("Descrivere il trattamento della non conformità con almeno 30 caratteri, oppure scegliere un’azione proposta.");
    if (missing.has("permanent_action")) {
        errors.push(
            detail.azione_non_necessaria
                ? "motivazione della mancata azione permanente non valida"
                : "azione permanente non verificabile"
        );
    }
    return errors;
}
